import {
  CustomizeBtn,
  DailyTargetTitle,
  DailyTargetWrapper,
  DailyText,
  YourDailyTargetHeader,
} from "./styled"
import PATHS from "router/paths"
import YourGoalDailyNutriton from "./YourGoalDailyNutriton"
import { IGoal } from "features/onboarding/types"
import { GOAL_WORDING } from "config"

const YourDailyTarget = ({
  goal,
  showCustomize = true,
}: {
  goal?: IGoal
  showCustomize?: boolean
}) => {
  return (
    <DailyTargetWrapper>
      <YourDailyTargetHeader $justify="space-between">
        <DailyTargetTitle>YOUR DAILY TARGET</DailyTargetTitle>
        {showCustomize && (
          <CustomizeBtn to={PATHS.app.yourGoal.manualEditGoal}>Customize</CustomizeBtn>
        )}
      </YourDailyTargetHeader>

      <YourGoalDailyNutriton goal={goal} />

      <DailyText>
        {goal
          ? GOAL_WORDING[goal.typeName]
              .split("\n")
              .map((paragraph, index) => <p key={index}>{paragraph}</p>)
          : ""}
      </DailyText>
    </DailyTargetWrapper>
  )
}

export default YourDailyTarget
